import { domainSearchErrorStatuses } from './domainSearchErrorStatuses';
import { actionStatuses } from './actionStatuses';
import { domainNameErrorStatuses } from './domainNameErrorStatuses';
export const Statuses = {
  ...actionStatuses,
  ...domainSearchErrorStatuses,
  ...domainNameErrorStatuses
};
//# sourceMappingURL=StatusesMap.js.map